import { Container } from "@mui/material";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import React from "react";

import "./homePage.scss";
import { Link } from "react-router-dom";

const Faqs = () => {
  const faqsData = [
    {
      title: "How do I place an order for rental items?",
      content:
        "You can place an order directly through our website enquiry form, or you can contact our customer service team for assistance. We're here to help you find the right products for business needs.",
    },
  ];
  return (
    <div className="faqs">
      <Container maxWidth="lg">
        <div className="faqs-container">
          <span>
            <h1>FAQs</h1>
            <h4>Still have doubts?</h4>
            <p>
              No worries contact
              <br /> us directly!
            </p>
          </span>
          <span>
            {faqsData.map((item, index) => (
              <Accordion
                className="accordion"
                key={index}
                defaultExpanded={true}
              >
                <AccordionSummary expandIcon={<ExpandCircleDownIcon />}>
                  <div className="faqs-title">{item.title}</div>
                </AccordionSummary>
                <AccordionDetails>
                  <p className="faqs-content">{item.content}</p>
                </AccordionDetails>
              </Accordion>
            ))}
            <div className="read-more-button">
              <Link to="/faqs">
                <button>Read more</button>
              </Link>
            </div>
          </span>
        </div>
      </Container>
    </div>
  );
};

export default Faqs;
